import { useEffect, useRef } from 'react';

/**
 * Fired on window whenever this tab changes the person's installs — install, uninstall, pause,
 * resume, settings, delete. Several widget surfaces can be mounted at once (the Widgets page,
 * the right-sidebar panel, home tiles, the Marketplace lists), each with its own copy of the
 * installed list; without this, resuming a widget in the sidebar left the Widgets page showing
 * "Paused" until a reload. Toolbox (MarketplacePage) dispatches the same event name.
 */
export const WIDGET_INSTALLS_CHANGED_EVENT = 'widgets:installs-changed';

export function notifyWidgetInstallsChanged(): void {
  window.dispatchEvent(new Event(WIDGET_INSTALLS_CHANGED_EVENT));
}

/** Calls `onChange` after any install change in this tab. The latest callback is always used,
 *  so callers don't need to memoise it. */
export function useWidgetInstallsChanged(onChange: () => void): void {
  const latest = useRef(onChange);
  latest.current = onChange;
  useEffect(() => {
    const handler = () => latest.current();
    window.addEventListener(WIDGET_INSTALLS_CHANGED_EVENT, handler);
    return () => window.removeEventListener(WIDGET_INSTALLS_CHANGED_EVENT, handler);
  }, []);
}
